// src/client/hooks/tasks/useGetUserTasks.js
import { getUserTasks } from "@/client/services/tasks/getUserTasks";
import { useApiQuery } from "@/shared/hooks/useApiQuery";

export const useGetUserTasks = ({ auth0UserId, accessToken }) => {
	return useApiQuery({
		queryKey: ["tasks", auth0UserId],
		queryFn: () => getUserTasks({ auth0UserId, accessToken }),
		accessToken,
		auth0UserId,
		enabled: !!accessToken && !!auth0UserId,
		staleTime: 0,
	});
};
